import api from "./api.service";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

const FLUSH_INTERVAL_MS = 10000;
const MAX_QUEUE_SIZE = 20;

export default class extends api {
  static _queue = [];
  static _timer = null;

  static enqueue(level, event, message, context = {}) {
    this._queue.push({
      level,
      event,
      message,
      context: { ...context, mode: process.env.VUE_APP_MODE },
      url: window.location.href,
      timestamp: new Date().toISOString(),
    });

    if (this._queue.length >= MAX_QUEUE_SIZE) {
      this.flush();
    } else if (!this._timer) {
      this._timer = setTimeout(() => this.flush(), FLUSH_INTERVAL_MS);
    }
  }

  static flush(useBeacon = false) {
    clearTimeout(this._timer);
    this._timer = null;

    if (this._queue.length === 0) return;

    const events = this._queue;
    this._queue = [];

    if (useBeacon && navigator.sendBeacon) {
      navigator.sendBeacon(
        API_SUFFIX + "/api/community-logs",
        new Blob([JSON.stringify({ events })], { type: "application/json" })
      );
      return;
    }

    return this.apiRequest(API_SUFFIX + "/api/community-logs", { events }, "POST").catch(() => {});
  }
}
